export const convertExtraTimeValue = (value: number) => {
  return Math.round(value * 100);
};
